import React from 'react'
import classNames from 'classnames'
import type { Props } from './types'
import Image from '@/components/image'
import styles from './style.module.scss'

const CategoryBubbleContent: React.FC<Props> = ({
  title,
  subtitle,
  text,
  color,
  image,
}) => {
  const classes = classNames(styles['category-bubble-content'])

  return (
    <div className={classes} style={{ border: `0.4rem solid ${color}` }}>
      {image && <Image data={image} extraClasses={styles.image} />}
      <span className={styles.title}>{title}</span>
      <span className={styles.subtitle}>{subtitle}</span>
      <span className={styles.text}>{text}</span>
    </div>
  )
}

export default React.memo(CategoryBubbleContent)
